import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Container, CssBaseline, Typography, TextField, Button } from '@material-ui/core'
import { saveAccount } from '../modules/app'
import { SelectBox } from './utils'
import { db } from '../firebase'
import { push } from 'connected-react-router'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const AccountEdit = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  let id = window.location.pathname.split('/accounts/edit')[1]
  if (id !== '') {
    id = id.split('/')[1]
  }

  const [name, setName] = useState('')
  const [type, setType] = useState('')
  const [person, setPerson] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [url, setUrl] = useState('')
  const [token, setToken] = useState('')
  const [mailText, setMailText] = useState('')
  const [mailSubject, setMailSubject] = useState('')
  const [cardTitle, setCardTitle] = useState('')
  const [cardBody, setCardBody] = useState('')
  const [address, setAddress] = useState('')
  const [limit, setLimit] = useState(10)
  const [list, setList] = useState('')
  const [buttonText, setButtonText] = useState('')
  const [redirect, setRedirect] = useState('')
  const [view, setView] = useState(true)

  const inputRedirect = useCallback(
    (event) => {
      setRedirect(event.target.value)
    },
    [setRedirect]
  )

  const inputButtonText = useCallback(
    (event) => {
      setButtonText(event.target.value)
    },
    [setButtonText]
  )

  const inputAddress = useCallback(
    (event) => {
      setAddress(event.target.value)
    },
    [setAddress]
  )

  const inputCardBody = useCallback(
    (event) => {
      setCardBody(event.target.value)
    },
    [setCardBody]
  )

  const inputCardTitle = useCallback(
    (event) => {
      setCardTitle(event.target.value)
    },
    [setCardTitle]
  )

  const inputList = useCallback(
    (event) => {
      setList(event.target.value)
    },
    [setList]
  )

  const inputMailSubject = useCallback(
    (event) => {
      setMailSubject(event.target.value)
    },
    [setMailSubject]
  )

  const inputMailText = useCallback(
    (event) => {
      setMailText(event.target.value)
    },
    [setMailText]
  )

  const inputPhone = useCallback(
    (event) => {
      setPhone(event.target.value)
    },
    [setPhone]
  )

  const inputName = useCallback(
    (event) => {
      setName(event.target.value)
    },
    [setName]
  )

  const inputEmail = useCallback(
    (event) => {
      setEmail(event.target.value)
    },
    [setEmail]
  )

  const inputPerson = useCallback(
    (event) => {
      setPerson(event.target.value)
    },
    [setPerson]
  )

  const inputUrl = useCallback(
    (event) => {
      setUrl(event.target.value)
    },
    [setUrl]
  )

  const inputToken = useCallback(
    (event) => {
      setToken(event.target.value)
    },
    [setToken]
  )

  const inputLimit = useCallback(
    (event) => {
      setLimit(event.target.value)
    },
    [setLimit]
  )

  const types = [
    { id: 'basic', name: 'basic' },
    { id: 'album', name: 'album' },
    { id: 'albummd', name: 'albummd' },
  ]

  const viewTypes = [
    { id: true, name: '公開する' },
    { id: false, name: '非公開' },
  ]

  useEffect(() => {
    if (id !== '') {
      db.collection('accounts')
        .doc(id)
        .get()
        .then((snapshot) => {
          const data = snapshot.data()
          setType(data.type)
          setName(data.name)
          setPerson(data.person)
          setEmail(data.email)
          setPhone(data.phone)
          setUrl(data.url)
          setToken(data.token)
          setMailSubject(data.mailSubject)
          setMailText(data.mailText)
          setCardTitle(data.cardTitle)
          setCardBody(data.cardBody)
          setLimit(data.limit)
          setAddress(data.address)
          setList(data.list.join())
          setRedirect(data.redirect)
          setButtonText(data.buttonText)
          setView(data.view === undefined ? true : data.view)
        })
    }
  }, [id])

  return (
    <Container component="main">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          アカウントの登録・編集
        </Typography>
        <div className={classes.form}>
          <TextField
            margin="dense"
            fullWidth
            label="医院名"
            required
            type="text"
            value={name}
            onChange={inputName}
          />
          <TextField
            margin="dense"
            fullWidth
            label="担当者名"
            required
            type="text"
            value={person}
            onChange={inputPerson}
          />
          <TextField
            margin="dense"
            fullWidth
            label="Eメールアドレス"
            required
            type="text"
            value={email}
            onChange={inputEmail}
          />
          <TextField
            margin="dense"
            fullWidth
            label="問合せの電話番号"
            required
            type="text"
            value={phone}
            onChange={inputPhone}
          />
          <TextField
            margin="dense"
            fullWidth
            label="医院の住所"
            required
            type="text"
            value={address}
            onChange={inputAddress}
          />
          <TextField
            margin="dense"
            fullWidth
            label="URL"
            required
            type="text"
            value={url}
            onChange={inputUrl}
          />
          <TextField
            margin="dense"
            fullWidth
            label="TOKEN"
            required
            type="text"
            value={token}
            onChange={inputToken}
          />
          <TextField
            margin="dense"
            fullWidth
            label="カードタイトル"
            required
            type="text"
            value={cardTitle}
            onChange={inputCardTitle}
          />
          <TextField
            margin="dense"
            fullWidth
            label="カード本文"
            multiline
            rows={10}
            required
            type="text"
            value={cardBody}
            onChange={inputCardBody}
          />
          <TextField
            margin="dense"
            fullWidth
            label="症状"
            multiline
            rows={5}
            required
            type="text"
            value={list}
            onChange={inputList}
          />
          <TextField
            margin="dense"
            fullWidth
            label="メールタイトル"
            required
            type="text"
            value={mailSubject}
            onChange={inputMailSubject}
          />
          <TextField
            margin="dense"
            fullWidth
            label="表示件数"
            required
            type="number"
            value={limit}
            onChange={inputLimit}
          />
          <TextField
            margin="dense"
            fullWidth
            label="送信ボタンのテキスト"
            required
            type="text"
            value={buttonText}
            onChange={inputButtonText}
          />
          <TextField
            margin="dense"
            fullWidth
            label="リダイレクト先"
            required
            type="text"
            value={redirect}
            onChange={inputRedirect}
          />
          <TextField
            margin="dense"
            multiline
            rows={10}
            fullWidth
            label="メールテキスト"
            required
            type="text"
            value={mailText}
            onChange={inputMailText}
          />
          <SelectBox label={'種類'} required={true} options={types} select={setType} value={type} />
          <SelectBox
            label={'公開'}
            required={true}
            options={viewTypes}
            select={setView}
            value={view}
          />
          <Button
            className={classes.submit}
            variant="contained"
            color="primary"
            onClick={() =>
              dispatch(
                saveAccount(
                  id,
                  type,
                  name,
                  person,
                  email,
                  phone,
                  address,
                  url,
                  token,
                  cardTitle,
                  cardBody,
                  mailSubject,
                  mailText,
                  limit,
                  list,
                  buttonText,
                  redirect,
                  view
                )
              )
            }
          >
            アカウント情報を保存
          </Button>
        </div>
        <Button
          onClick={() => {
            dispatch(push('/accounts'))
          }}
        >
          一覧に戻る
        </Button>
      </div>
    </Container>
  )
}

export default AccountEdit
